import { useResponsiveMobile } from "../../../hooks/useResponsiveMobile";
import "./../../../index.css";

export const Section6 = () => {
  const isMobile = useResponsiveMobile(900);
  const logos = [
    "/assets/images/logo/wisecare.png",
    "/assets/images/logo/wayup.png",
    "/assets/images/logo/paytus.png",
    "/assets/images/logo/kis.png",
    "/assets/images/logo/kurly.png",
    "/assets/images/logo/paystory.png",
    "/assets/images/logo/korpay.png",
    "/assets/images/logo/passgo.png",
    "/assets/images/logo/ud.png",

    "/assets/images/logo/lotte.png",
    "/assets/images/logo/kb.png",

    "/assets/images/logo/nice.png",
    "/assets/images/logo/flserv.png",
    "/assets/images/logo/tmoney.png",
    "/assets/images/logo/todayhouse.png",
    "/assets/images/logo/smartro.png",
    "/assets/images/logo/monki.png",
    "/assets/images/logo/paystore.png",
    "/assets/images/logo/wholebig.png",
    "/assets/images/logo/moin.png",
    "/assets/images/logo/manna.png",
    "/assets/images/logo/paytus.png",
    "/assets/images/logo/yumyum.png",
    "/assets/images/logo/skyclass.png",
    "/assets/images/logo/chungho.png",
    "/assets/images/logo/korbill.png",
    "/assets/images/logo/cellfieglobal.png",
    "/assets/images/logo/twc.png",
    "/assets/images/logo/beaverworks.png",
    "/assets/images/logo/damapay.png",
    "/assets/images/logo/obesis.png",
    "/assets/images/logo/law.png",
    "/assets/images/logo/koreaculture.png",
    "/assets/images/logo/rom.png",
    "/assets/images/logo/seed.png",
    "/assets/images/logo/raemi.png",
    "/assets/images/logo/cellfie.png",
    "/assets/images/logo/hello.png",
    "/assets/images/logo/c1.png",
    "/assets/images/logo/urgent.png",
    "/assets/images/logo/finger.png",
    "/assets/images/logo/buddy.png",
    "/assets/images/logo/payment.png",
    "/assets/images/logo/npi.png",
    "/assets/images/logo/kingorder.png",
    "/assets/images/logo/iaurora.png",
    "/assets/images/logo/connectree.png",
    "/assets/images/logo/pmgrow.png",
    "/assets/images/logo/wonik.png",
    "/assets/images/logo/pne.png",
    "/assets/images/logo/costel.png",
    "/assets/images/logo/adt.png",
    "/assets/images/logo/nobletree.png",
    "/assets/images/logo/bithumb.png",
  ];

  const splitLogosForMobile = (logos: string[]) => {
    const rows = [[], [], []] as string[][];
    logos.forEach((logo, idx) => {
      rows[idx % 3].push(logo);
    });
    return rows;
  };

  const mobileRows = splitLogosForMobile(logos);
  return (
    <section className="flex flex-col gap-[40px] md:gap-[80px] justify-center w-full items-center overflow-hidden px-4 pb-[120px] md:pb-[160px]">
      <div className="flex flex-col gap-[32px] md:gap-[50px]">
        <div className="flex flex-col gap-3">
          <span className="text-xl text-[#0079FF] font-normal text-center">위지온 소개</span>
          <span className="text-[36px] md:text-display font-bold text-center">
            핀테크 전문기업 <br /> 위지온이 만듭니다
          </span>
        </div>
        {isMobile ? (
          <span className="text-[18px] text-[#4D4F58] font-normal text-center">
            다양한 업계의 결제 솔루션 구축/운영 경험으로 <br />
            검증된 안정성과 전문성을 바탕으로 합니다.
          </span>
        ) : (
          <span className="text-[18px] md:text-heading1 text-[#4D4F58] font-normal text-center">
            다양한 업계의 결제 솔루션 구축/운영 경험으로 <br />
            검증된 안정성과 전문성을 바탕으로 합니다.
          </span>
        )}
      </div>

      {/* 🔁 로고 캐러셀 */}
      <div className="relative w-full overflow-hidden">
        {isMobile ? (
          <div className="flex flex-col">
            {mobileRows.map((row, rowIdx) => (
              <div key={rowIdx} className="relative w-full overflow-hidden">
                <div className="logo-track">
                  {[...row, ...row].map((src, idx) => (
                    <img
                      loading="lazy"
                      key={idx}
                      src={src}
                      className="w-20 h-[35px] object-contain opacity-80"
                      draggable={false}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="logo-track">
            {[...logos, ...logos].map((src, idx) => (
              <img
                loading="lazy"
                key={idx}
                src={src}
                className="w-full max-w-[180px] h-auto object-contain opacity-80"
                draggable={false}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
